module.exports = __webpack_public_path__ + "media/application/images/demo/main2-f1dd073fd2192c94e047f715a53c3632.jpg";